/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Web Dispatcher - spring-backend
 * API documentation for developers
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbsenceSalaryMappingDTO,
  AbsenceSalaryMappingOverviewDTO,
  CalendarJSON,
  ErrorDetails,
  FinagoTimeEventMappingOverviewDTO,
  FinagoTimeSyncRequestDTO,
  GetAllAbsenceSalaryMappingsParams,
  GetAllEventsParams,
  GetEventsBetweenParams,
  GetTimeTrackingEntriesParams,
  ImportSeveraAbsencesBody,
  ImportSeveraWorkhoursBody,
  PatchCalendarEvent1Body,
  PersonVacationBalanceJSON,
  TimeTrackingEntryDTO,
  TimeTrackingSyncResultDTO
} from '../../model';

import { useCustomInstance } from '../../mutator/use-custom-instance.ts';
import type { ErrorType , BodyType } from '../../mutator/use-custom-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Edits a list of Finago Time event type mappings
 * @summary Batch edit Finago Time event mappings
 */
export const editFinagoTimeEventMappingBatch = (
    finagoTimeEventMappingOverviewDTO: BodyType<FinagoTimeEventMappingOverviewDTO[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/calendar/time-tracking/mappings/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: finagoTimeEventMappingOverviewDTO, signal
    },
      options);
    }



export const getEditFinagoTimeEventMappingBatchMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editFinagoTimeEventMappingBatch>>, TError,{data: BodyType<FinagoTimeEventMappingOverviewDTO[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof editFinagoTimeEventMappingBatch>>, TError,{data: BodyType<FinagoTimeEventMappingOverviewDTO[]>}, TContext> => {

const mutationKey = ['editFinagoTimeEventMappingBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editFinagoTimeEventMappingBatch>>, {data: BodyType<FinagoTimeEventMappingOverviewDTO[]>}> = (props) => {
          const {data} = props ?? {};

          return  editFinagoTimeEventMappingBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditFinagoTimeEventMappingBatchMutationResult = NonNullable<Awaited<ReturnType<typeof editFinagoTimeEventMappingBatch>>>
    export type EditFinagoTimeEventMappingBatchMutationBody = BodyType<FinagoTimeEventMappingOverviewDTO[]>
    export type EditFinagoTimeEventMappingBatchMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Batch edit Finago Time event mappings
 */
export const useEditFinagoTimeEventMappingBatch = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editFinagoTimeEventMappingBatch>>, TError,{data: BodyType<FinagoTimeEventMappingOverviewDTO[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editFinagoTimeEventMappingBatch>>,
        TError,
        {data: BodyType<FinagoTimeEventMappingOverviewDTO[]>},
        TContext
      > => {
      return useMutation(getEditFinagoTimeEventMappingBatchMutationOptions(options), queryClient);
    }
    /**
 * Endpoint for batch edit
 * @summary Batch edit mapping
 */
export const editAbsenceSalaryMappingBatch = (
    absenceSalaryMappingOverviewDTO: BodyType<AbsenceSalaryMappingOverviewDTO[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/calendar/mappings/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: absenceSalaryMappingOverviewDTO, signal
    },
      options);
    }



export const getEditAbsenceSalaryMappingBatchMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editAbsenceSalaryMappingBatch>>, TError,{data: BodyType<AbsenceSalaryMappingOverviewDTO[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof editAbsenceSalaryMappingBatch>>, TError,{data: BodyType<AbsenceSalaryMappingOverviewDTO[]>}, TContext> => {

const mutationKey = ['editAbsenceSalaryMappingBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editAbsenceSalaryMappingBatch>>, {data: BodyType<AbsenceSalaryMappingOverviewDTO[]>}> = (props) => {
          const {data} = props ?? {};

          return  editAbsenceSalaryMappingBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditAbsenceSalaryMappingBatchMutationResult = NonNullable<Awaited<ReturnType<typeof editAbsenceSalaryMappingBatch>>>
    export type EditAbsenceSalaryMappingBatchMutationBody = BodyType<AbsenceSalaryMappingOverviewDTO[]>
    export type EditAbsenceSalaryMappingBatchMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Batch edit mapping
 */
export const useEditAbsenceSalaryMappingBatch = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editAbsenceSalaryMappingBatch>>, TError,{data: BodyType<AbsenceSalaryMappingOverviewDTO[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editAbsenceSalaryMappingBatch>>,
        TError,
        {data: BodyType<AbsenceSalaryMappingOverviewDTO[]>},
        TContext
      > => {
      return useMutation(getEditAbsenceSalaryMappingBatchMutationOptions(options), queryClient);
    }
    /**
 * Creates mapping rows for all HR event types if not yet present. Requires Finago Time to be configured.
 * @summary Initialize default Finago Time event mappings
 */
export const initializeFinagoTimeEventMappings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/calendar/time-tracking/mappings/initialize`, method: 'POST', signal
    },
      options);
    }



export const getInitializeFinagoTimeEventMappingsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeFinagoTimeEventMappings>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeFinagoTimeEventMappings>>, TError,void, TContext> => {

const mutationKey = ['initializeFinagoTimeEventMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeFinagoTimeEventMappings>>, void> = () => {


          return  initializeFinagoTimeEventMappings(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitializeFinagoTimeEventMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof initializeFinagoTimeEventMappings>>>

    export type InitializeFinagoTimeEventMappingsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Initialize default Finago Time event mappings
 */
export const useInitializeFinagoTimeEventMappings = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeFinagoTimeEventMappings>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeFinagoTimeEventMappings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getInitializeFinagoTimeEventMappingsMutationOptions(options), queryClient);
    }
    /**
 * Runs manual synchronization for approved time-tracking work hours and overtimes. Optional filters: startDate, endDate, deleted (all default to null).
 * @summary Sync time-tracking work hours and overtimes
 */
export const syncTimeTrackingWorkHoursAndOvertimes = (
    finagoTimeSyncRequestDTO?: BodyType<FinagoTimeSyncRequestDTO>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<TimeTrackingSyncResultDTO>(
      {url: `/api/v1/rest/calendar/sync/time-tracking/work-hours-and-overtimes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: finagoTimeSyncRequestDTO, signal
    },
      options);
    }



export const getSyncTimeTrackingWorkHoursAndOvertimesMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTimeTrackingWorkHoursAndOvertimes>>, TError,{data?: BodyType<FinagoTimeSyncRequestDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof syncTimeTrackingWorkHoursAndOvertimes>>, TError,{data?: BodyType<FinagoTimeSyncRequestDTO>}, TContext> => {

const mutationKey = ['syncTimeTrackingWorkHoursAndOvertimes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTimeTrackingWorkHoursAndOvertimes>>, {data?: BodyType<FinagoTimeSyncRequestDTO>}> = (props) => {
          const {data} = props ?? {};

          return  syncTimeTrackingWorkHoursAndOvertimes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncTimeTrackingWorkHoursAndOvertimesMutationResult = NonNullable<Awaited<ReturnType<typeof syncTimeTrackingWorkHoursAndOvertimes>>>
    export type SyncTimeTrackingWorkHoursAndOvertimesMutationBody = BodyType<FinagoTimeSyncRequestDTO> | undefined
    export type SyncTimeTrackingWorkHoursAndOvertimesMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Sync time-tracking work hours and overtimes
 */
export const useSyncTimeTrackingWorkHoursAndOvertimes = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTimeTrackingWorkHoursAndOvertimes>>, TError,{data?: BodyType<FinagoTimeSyncRequestDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncTimeTrackingWorkHoursAndOvertimes>>,
        TError,
        {data?: BodyType<FinagoTimeSyncRequestDTO>},
        TContext
      > => {
      return useMutation(getSyncTimeTrackingWorkHoursAndOvertimesMutationOptions(options), queryClient);
    }
    /**
 * Runs manual synchronization for approved time-tracking absences. Optional filters: startDate, endDate, deleted (all default to null).
 * @summary Sync time-tracking absences
 */
export const syncTimeTrackingAbsences = (
    finagoTimeSyncRequestDTO?: BodyType<FinagoTimeSyncRequestDTO>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<TimeTrackingSyncResultDTO>(
      {url: `/api/v1/rest/calendar/sync/time-tracking/absences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: finagoTimeSyncRequestDTO, signal
    },
      options);
    }



export const getSyncTimeTrackingAbsencesMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTimeTrackingAbsences>>, TError,{data?: BodyType<FinagoTimeSyncRequestDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof syncTimeTrackingAbsences>>, TError,{data?: BodyType<FinagoTimeSyncRequestDTO>}, TContext> => {

const mutationKey = ['syncTimeTrackingAbsences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncTimeTrackingAbsences>>, {data?: BodyType<FinagoTimeSyncRequestDTO>}> = (props) => {
          const {data} = props ?? {};

          return  syncTimeTrackingAbsences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncTimeTrackingAbsencesMutationResult = NonNullable<Awaited<ReturnType<typeof syncTimeTrackingAbsences>>>
    export type SyncTimeTrackingAbsencesMutationBody = BodyType<FinagoTimeSyncRequestDTO> | undefined
    export type SyncTimeTrackingAbsencesMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Sync time-tracking absences
 */
export const useSyncTimeTrackingAbsences = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncTimeTrackingAbsences>>, TError,{data?: BodyType<FinagoTimeSyncRequestDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncTimeTrackingAbsences>>,
        TError,
        {data?: BodyType<FinagoTimeSyncRequestDTO>},
        TContext
      > => {
      return useMutation(getSyncTimeTrackingAbsencesMutationOptions(options), queryClient);
    }
    /**
 * Endpoint to get all mappings
 * @summary Get all mappings
 */
export const getAllAbsenceSalaryMappings = (
    params?: GetAllAbsenceSalaryMappingsParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<AbsenceSalaryMappingOverviewDTO[]>(
      {url: `/api/v1/rest/calendar/mappings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAllAbsenceSalaryMappingsQueryKey = (params?: GetAllAbsenceSalaryMappingsParams,) => {
    return [
    `/api/v1/rest/calendar/mappings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAllAbsenceSalaryMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError = ErrorType<ErrorDetails>>(params?: GetAllAbsenceSalaryMappingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAbsenceSalaryMappingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>> = ({ signal }) => getAllAbsenceSalaryMappings(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllAbsenceSalaryMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>>
export type GetAllAbsenceSalaryMappingsQueryError = ErrorType<ErrorDetails>


export function useGetAllAbsenceSalaryMappings<TData = Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError = ErrorType<ErrorDetails>>(
 params: undefined |  GetAllAbsenceSalaryMappingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllAbsenceSalaryMappings<TData = Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError = ErrorType<ErrorDetails>>(
 params?: GetAllAbsenceSalaryMappingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllAbsenceSalaryMappings<TData = Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError = ErrorType<ErrorDetails>>(
 params?: GetAllAbsenceSalaryMappingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all mappings
 */

export function useGetAllAbsenceSalaryMappings<TData = Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError = ErrorType<ErrorDetails>>(
 params?: GetAllAbsenceSalaryMappingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAbsenceSalaryMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllAbsenceSalaryMappingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Endpoint to create mapping
 * @summary Create mapping
 */
export const createExternalMapping = (
    absenceSalaryMappingDTO: BodyType<AbsenceSalaryMappingDTO>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<AbsenceSalaryMappingOverviewDTO>(
      {url: `/api/v1/rest/calendar/mappings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: absenceSalaryMappingDTO, signal
    },
      options);
    }



export const getCreateExternalMappingMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalMapping>>, TError,{data: BodyType<AbsenceSalaryMappingDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createExternalMapping>>, TError,{data: BodyType<AbsenceSalaryMappingDTO>}, TContext> => {

const mutationKey = ['createExternalMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExternalMapping>>, {data: BodyType<AbsenceSalaryMappingDTO>}> = (props) => {
          const {data} = props ?? {};

          return  createExternalMapping(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExternalMappingMutationResult = NonNullable<Awaited<ReturnType<typeof createExternalMapping>>>
    export type CreateExternalMappingMutationBody = BodyType<AbsenceSalaryMappingDTO>
    export type CreateExternalMappingMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create mapping
 */
export const useCreateExternalMapping = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalMapping>>, TError,{data: BodyType<AbsenceSalaryMappingDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExternalMapping>>,
        TError,
        {data: BodyType<AbsenceSalaryMappingDTO>},
        TContext
      > => {
      return useMutation(getCreateExternalMappingMutationOptions(options), queryClient);
    }
    /**
 * Initializes default mappings for absences for the authenticated company.
 * @summary Initialize default absence salary mappings
 */
export const initializeAbsenceSalaryMappings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/calendar/mappings/initialize`, method: 'POST', signal
    },
      options);
    }



export const getInitializeAbsenceSalaryMappingsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeAbsenceSalaryMappings>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeAbsenceSalaryMappings>>, TError,void, TContext> => {

const mutationKey = ['initializeAbsenceSalaryMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeAbsenceSalaryMappings>>, void> = () => {


          return  initializeAbsenceSalaryMappings(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitializeAbsenceSalaryMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof initializeAbsenceSalaryMappings>>>

    export type InitializeAbsenceSalaryMappingsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Initialize default absence salary mappings
 */
export const useInitializeAbsenceSalaryMappings = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeAbsenceSalaryMappings>>, TError,void, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeAbsenceSalaryMappings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getInitializeAbsenceSalaryMappingsMutationOptions(options), queryClient);
    }
    /**
 * Import all calendar workhour events from Visma Severa for the company
 * @summary Import calendar workhour events from Severa
 */
export const importSeveraWorkhours = (
    importSeveraWorkhoursBody: BodyType<ImportSeveraWorkhoursBody>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<CalendarJSON[]>(
      {url: `/api/v1/rest/calendar/import/severa/workhours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importSeveraWorkhoursBody, signal
    },
      options);
    }



export const getImportSeveraWorkhoursMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSeveraWorkhours>>, TError,{data: BodyType<ImportSeveraWorkhoursBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importSeveraWorkhours>>, TError,{data: BodyType<ImportSeveraWorkhoursBody>}, TContext> => {

const mutationKey = ['importSeveraWorkhours'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importSeveraWorkhours>>, {data: BodyType<ImportSeveraWorkhoursBody>}> = (props) => {
          const {data} = props ?? {};

          return  importSeveraWorkhours(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportSeveraWorkhoursMutationResult = NonNullable<Awaited<ReturnType<typeof importSeveraWorkhours>>>
    export type ImportSeveraWorkhoursMutationBody = BodyType<ImportSeveraWorkhoursBody>
    export type ImportSeveraWorkhoursMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Import calendar workhour events from Severa
 */
export const useImportSeveraWorkhours = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSeveraWorkhours>>, TError,{data: BodyType<ImportSeveraWorkhoursBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importSeveraWorkhours>>,
        TError,
        {data: BodyType<ImportSeveraWorkhoursBody>},
        TContext
      > => {
      return useMutation(getImportSeveraWorkhoursMutationOptions(options), queryClient);
    }
    /**
 * Import all calendar absence events from Visma Severa for the company
 * @summary Import calendar absence events from Severa
 */
export const importSeveraAbsences = (
    importSeveraAbsencesBody: BodyType<ImportSeveraAbsencesBody>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<CalendarJSON[]>(
      {url: `/api/v1/rest/calendar/import/severa/absences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importSeveraAbsencesBody, signal
    },
      options);
    }



export const getImportSeveraAbsencesMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSeveraAbsences>>, TError,{data: BodyType<ImportSeveraAbsencesBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importSeveraAbsences>>, TError,{data: BodyType<ImportSeveraAbsencesBody>}, TContext> => {

const mutationKey = ['importSeveraAbsences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importSeveraAbsences>>, {data: BodyType<ImportSeveraAbsencesBody>}> = (props) => {
          const {data} = props ?? {};

          return  importSeveraAbsences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportSeveraAbsencesMutationResult = NonNullable<Awaited<ReturnType<typeof importSeveraAbsences>>>
    export type ImportSeveraAbsencesMutationBody = BodyType<ImportSeveraAbsencesBody>
    export type ImportSeveraAbsencesMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Import calendar absence events from Severa
 */
export const useImportSeveraAbsences = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSeveraAbsences>>, TError,{data: BodyType<ImportSeveraAbsencesBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importSeveraAbsences>>,
        TError,
        {data: BodyType<ImportSeveraAbsencesBody>},
        TContext
      > => {
      return useMutation(getImportSeveraAbsencesMutationOptions(options), queryClient);
    }
    /**
 * Adds a new event to the calendar
 * @summary Create a calendar event
 */
export const createCalendarEvent = (
    calendarJSON: BodyType<CalendarJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<CalendarJSON>(
      {url: `/api/v1/rest/calendar/event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: calendarJSON, signal
    },
      options);
    }



export const getCreateCalendarEventMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{data: BodyType<CalendarJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{data: BodyType<CalendarJSON>}, TContext> => {

const mutationKey = ['createCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCalendarEvent>>, {data: BodyType<CalendarJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createCalendarEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof createCalendarEvent>>>
    export type CreateCalendarEventMutationBody = BodyType<CalendarJSON>
    export type CreateCalendarEventMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create a calendar event
 */
export const useCreateCalendarEvent = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{data: BodyType<CalendarJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCalendarEvent>>,
        TError,
        {data: BodyType<CalendarJSON>},
        TContext
      > => {
      return useMutation(getCreateCalendarEventMutationOptions(options), queryClient);
    }
    /**
 * Calculate vacation days and Saturdays of given date range
 * @summary Calculate vacation days and Saturdays
 */
export const calculateVacationDaysAndSaturdays = (
    calendarJSON: BodyType<CalendarJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonVacationBalanceJSON>(
      {url: `/api/v1/rest/calendar/calculate-event-vacation-days`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: calendarJSON, signal
    },
      options);
    }



export const getCalculateVacationDaysAndSaturdaysMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateVacationDaysAndSaturdays>>, TError,{data: BodyType<CalendarJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calculateVacationDaysAndSaturdays>>, TError,{data: BodyType<CalendarJSON>}, TContext> => {

const mutationKey = ['calculateVacationDaysAndSaturdays'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculateVacationDaysAndSaturdays>>, {data: BodyType<CalendarJSON>}> = (props) => {
          const {data} = props ?? {};

          return  calculateVacationDaysAndSaturdays(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalculateVacationDaysAndSaturdaysMutationResult = NonNullable<Awaited<ReturnType<typeof calculateVacationDaysAndSaturdays>>>
    export type CalculateVacationDaysAndSaturdaysMutationBody = BodyType<CalendarJSON>
    export type CalculateVacationDaysAndSaturdaysMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Calculate vacation days and Saturdays
 */
export const useCalculateVacationDaysAndSaturdays = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateVacationDaysAndSaturdays>>, TError,{data: BodyType<CalendarJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calculateVacationDaysAndSaturdays>>,
        TError,
        {data: BodyType<CalendarJSON>},
        TContext
      > => {
      return useMutation(getCalculateVacationDaysAndSaturdaysMutationOptions(options), queryClient);
    }
    /**
 * Modify calendar status for given ids
 * @summary Patch calendar status
 */
export const patchCalendarStatus = (
    status: string,
    patchCalendarStatusBody: BodyType<number[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<string>(
      {url: `/api/v1/rest/calendar/status/${status}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchCalendarStatusBody, signal
    },
      options);
    }



export const getPatchCalendarStatusMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCalendarStatus>>, TError,{status: string;data: BodyType<number[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCalendarStatus>>, TError,{status: string;data: BodyType<number[]>}, TContext> => {

const mutationKey = ['patchCalendarStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCalendarStatus>>, {status: string;data: BodyType<number[]>}> = (props) => {
          const {status,data} = props ?? {};

          return  patchCalendarStatus(status,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchCalendarStatusMutationResult = NonNullable<Awaited<ReturnType<typeof patchCalendarStatus>>>
    export type PatchCalendarStatusMutationBody = BodyType<number[]>
    export type PatchCalendarStatusMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Patch calendar status
 */
export const usePatchCalendarStatus = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCalendarStatus>>, TError,{status: string;data: BodyType<number[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCalendarStatus>>,
        TError,
        {status: string;data: BodyType<number[]>},
        TContext
      > => {
      return useMutation(getPatchCalendarStatusMutationOptions(options), queryClient);
    }
    /**
 * Delete an event from the calendar
 * @summary Delete a calendar event
 */
export const deleteCalendarEvent1 = (
    eventId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/calendar/event/${eventId}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteCalendarEvent1MutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarEvent1>>, TError,{eventId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarEvent1>>, TError,{eventId: number}, TContext> => {

const mutationKey = ['deleteCalendarEvent1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCalendarEvent1>>, {eventId: number}> = (props) => {
          const {eventId} = props ?? {};

          return  deleteCalendarEvent1(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCalendarEvent1MutationResult = NonNullable<Awaited<ReturnType<typeof deleteCalendarEvent1>>>

    export type DeleteCalendarEvent1MutationError = ErrorType<ErrorDetails>

    /**
 * @summary Delete a calendar event
 */
export const useDeleteCalendarEvent1 = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarEvent1>>, TError,{eventId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCalendarEvent1>>,
        TError,
        {eventId: number},
        TContext
      > => {
      return useMutation(getDeleteCalendarEvent1MutationOptions(options), queryClient);
    }
    /**
 * Modify calendar data
 * @summary Patch a calendar event
 */
export const patchCalendarEvent1 = (
    eventId: number,
    patchCalendarEvent1Body: BodyType<PatchCalendarEvent1Body>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<string>(
      {url: `/api/v1/rest/calendar/event/${eventId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchCalendarEvent1Body, signal
    },
      options);
    }



export const getPatchCalendarEvent1MutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCalendarEvent1>>, TError,{eventId: number;data: BodyType<PatchCalendarEvent1Body>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCalendarEvent1>>, TError,{eventId: number;data: BodyType<PatchCalendarEvent1Body>}, TContext> => {

const mutationKey = ['patchCalendarEvent1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCalendarEvent1>>, {eventId: number;data: BodyType<PatchCalendarEvent1Body>}> = (props) => {
          const {eventId,data} = props ?? {};

          return  patchCalendarEvent1(eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchCalendarEvent1MutationResult = NonNullable<Awaited<ReturnType<typeof patchCalendarEvent1>>>
    export type PatchCalendarEvent1MutationBody = BodyType<PatchCalendarEvent1Body>
    export type PatchCalendarEvent1MutationError = ErrorType<ErrorDetails>

    /**
 * @summary Patch a calendar event
 */
export const usePatchCalendarEvent1 = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCalendarEvent1>>, TError,{eventId: number;data: BodyType<PatchCalendarEvent1Body>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCalendarEvent1>>,
        TError,
        {eventId: number;data: BodyType<PatchCalendarEvent1Body>},
        TContext
      > => {
      return useMutation(getPatchCalendarEvent1MutationOptions(options), queryClient);
    }
    /**
 * Returns all Finago Time event type mappings for the authenticated company
 * @summary Get all Finago Time event mappings
 */
export const getAllFinagoTimeEventMappings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<FinagoTimeEventMappingOverviewDTO[]>(
      {url: `/api/v1/rest/calendar/time-tracking/mappings`, method: 'GET', signal
    },
      options);
    }




export const getGetAllFinagoTimeEventMappingsQueryKey = () => {
    return [
    `/api/v1/rest/calendar/time-tracking/mappings`
    ] as const;
    }


export const getGetAllFinagoTimeEventMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFinagoTimeEventMappingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>> = ({ signal }) => getAllFinagoTimeEventMappings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllFinagoTimeEventMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>>
export type GetAllFinagoTimeEventMappingsQueryError = ErrorType<ErrorDetails>


export function useGetAllFinagoTimeEventMappings<TData = Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllFinagoTimeEventMappings<TData = Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllFinagoTimeEventMappings<TData = Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all Finago Time event mappings
 */

export function useGetAllFinagoTimeEventMappings<TData = Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFinagoTimeEventMappings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllFinagoTimeEventMappingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns list of absences or work hours/overtimes depending on type. Required: type. Optional filters: startTime, endTime.
 * @summary Get time-tracking entries
 */
export const getTimeTrackingEntries = (
    params: GetTimeTrackingEntriesParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<TimeTrackingEntryDTO[]>(
      {url: `/api/v1/rest/calendar/time-tracking/entries`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTimeTrackingEntriesQueryKey = (params?: GetTimeTrackingEntriesParams,) => {
    return [
    `/api/v1/rest/calendar/time-tracking/entries`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTimeTrackingEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError = ErrorType<ErrorDetails>>(params: GetTimeTrackingEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeTrackingEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeTrackingEntries>>> = ({ signal }) => getTimeTrackingEntries(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTimeTrackingEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getTimeTrackingEntries>>>
export type GetTimeTrackingEntriesQueryError = ErrorType<ErrorDetails>


export function useGetTimeTrackingEntries<TData = Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError = ErrorType<ErrorDetails>>(
 params: GetTimeTrackingEntriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimeTrackingEntries>>,
          TError,
          Awaited<ReturnType<typeof getTimeTrackingEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimeTrackingEntries<TData = Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError = ErrorType<ErrorDetails>>(
 params: GetTimeTrackingEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimeTrackingEntries>>,
          TError,
          Awaited<ReturnType<typeof getTimeTrackingEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimeTrackingEntries<TData = Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError = ErrorType<ErrorDetails>>(
 params: GetTimeTrackingEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get time-tracking entries
 */

export function useGetTimeTrackingEntries<TData = Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError = ErrorType<ErrorDetails>>(
 params: GetTimeTrackingEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimeTrackingEntries>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimeTrackingEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of calendar events between given dates. Use team=true to filter by supervisor relationships and mask sensitive data for team members.
 * @summary Get events between
 */
export const getEventsBetween = (
    startDate: string,
    endDate: string,
    params?: GetEventsBetweenParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<CalendarJSON[]>(
      {url: `/api/v1/rest/calendar/events/from/${startDate}/to/${endDate}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEventsBetweenQueryKey = (startDate: string,
    endDate: string,
    params?: GetEventsBetweenParams,) => {
    return [
    `/api/v1/rest/calendar/events/from/${startDate}/to/${endDate}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventsBetweenQueryOptions = <TData = Awaited<ReturnType<typeof getEventsBetween>>, TError = ErrorType<ErrorDetails>>(startDate: string,
    endDate: string,
    params?: GetEventsBetweenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBetween>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsBetweenQueryKey(startDate,endDate,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsBetween>>> = ({ signal }) => getEventsBetween(startDate,endDate,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: startDate !== null && startDate !== undefined && endDate !== null && endDate !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsBetween>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsBetweenQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsBetween>>>
export type GetEventsBetweenQueryError = ErrorType<ErrorDetails>


export function useGetEventsBetween<TData = Awaited<ReturnType<typeof getEventsBetween>>, TError = ErrorType<ErrorDetails>>(
 startDate: string,
    endDate: string,
    params: undefined |  GetEventsBetweenParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBetween>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsBetween>>,
          TError,
          Awaited<ReturnType<typeof getEventsBetween>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsBetween<TData = Awaited<ReturnType<typeof getEventsBetween>>, TError = ErrorType<ErrorDetails>>(
 startDate: string,
    endDate: string,
    params?: GetEventsBetweenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBetween>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsBetween>>,
          TError,
          Awaited<ReturnType<typeof getEventsBetween>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsBetween<TData = Awaited<ReturnType<typeof getEventsBetween>>, TError = ErrorType<ErrorDetails>>(
 startDate: string,
    endDate: string,
    params?: GetEventsBetweenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBetween>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get events between
 */

export function useGetEventsBetween<TData = Awaited<ReturnType<typeof getEventsBetween>>, TError = ErrorType<ErrorDetails>>(
 startDate: string,
    endDate: string,
    params?: GetEventsBetweenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsBetween>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsBetweenQueryOptions(startDate,endDate,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of all calendar events for the company. Optionally filter by personId, dateFrom, dateTo.
 * @summary Get all events
 */
export const getAllEvents = (
    params?: GetAllEventsParams,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<CalendarJSON[]>(
      {url: `/api/v1/rest/calendar/events/all`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAllEventsQueryKey = (params?: GetAllEventsParams,) => {
    return [
    `/api/v1/rest/calendar/events/all`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAllEventsQueryOptions = <TData = Awaited<ReturnType<typeof getAllEvents>>, TError = ErrorType<ErrorDetails>>(params?: GetAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllEvents>>> = ({ signal }) => getAllEvents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllEvents>>>
export type GetAllEventsQueryError = ErrorType<ErrorDetails>


export function useGetAllEvents<TData = Awaited<ReturnType<typeof getAllEvents>>, TError = ErrorType<ErrorDetails>>(
 params: undefined |  GetAllEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllEvents>>,
          TError,
          Awaited<ReturnType<typeof getAllEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllEvents<TData = Awaited<ReturnType<typeof getAllEvents>>, TError = ErrorType<ErrorDetails>>(
 params?: GetAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllEvents>>,
          TError,
          Awaited<ReturnType<typeof getAllEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllEvents<TData = Awaited<ReturnType<typeof getAllEvents>>, TError = ErrorType<ErrorDetails>>(
 params?: GetAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all events
 */

export function useGetAllEvents<TData = Awaited<ReturnType<typeof getAllEvents>>, TError = ErrorType<ErrorDetails>>(
 params?: GetAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllEvents>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






